import { useEffect } from 'react';
import { isSSR, window } from './browser';
var testImg = isSSR() || typeof Image === 'undefined' ? { style: {} } : new Image();
export var isObjectFitSupported = 'object-fit' in testImg.style;
// Based on https://stackoverflow.com/a/42543908
export function getScrollParent(element, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.includeHidden, includeHidden = _c === void 0 ? false : _c;
    var style = window.getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;
    if (style.position === 'fixed') {
        return window;
    }
    // eslint-disable-next-line no-cond-assign
    for (var parent_1 = element; (parent_1 = parent_1.parentElement);) {
        style = window.getComputedStyle(parent_1);
        if (excludeStaticParent && style.position === 'static') {
            // eslint-disable-next-line no-continue
            continue;
        }
        var overflow = "".concat(style.overflow, " ").concat(style.overflowY, " ").concat(style.overflowX);
        if (overflowRegex.test(overflow)) {
            return parent_1;
        }
    }
    return window;
}
export var detectImageDimensions = function (src) {
    return new Promise(function (resolve) {
        var img = new Image();
        var listener = function () {
            var width = img.naturalWidth, height = img.naturalHeight;
            resolve({ width: width, height: height });
            img.removeEventListener('load', listener);
        };
        img.addEventListener('load', listener);
        img.src = src;
    });
};
export var useEventListener = function (handler, eventType, target) {
    if (target === void 0) { target = window; }
    useEffect(function () {
        target.addEventListener(eventType, handler);
        return function () { return target.removeEventListener(eventType, handler); };
    }, [handler, target, eventType]);
};
/**
 * This is an event handler that wraps and returns a callback that can be used
 * for onClick and onKeyPress props. The component will then handle onClick and
 * onKeyPress events with the provided callback method and will conform to aria
 * key press standards.  Being Aria compliant means that only the Enter or
 * Spacebar keys should trigger an "onKeypress" event.  You should also set the
 * tabIndex and aria "role" on the component.
 *
 * @param callback Handler to be invoked on key press or click event
 */
export var buildButtonClickAndKeypressHandler = function (callback) {
    return function (e) {
        if ((e.type === 'keypress' && ['Enter', 'Space', 'Spacebar', ' '].includes(e.key)) ||
            e.type === 'click') {
            callback(e);
        }
    };
};
